import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const [activeClientId, setActiveClientId] = useState(
    () => localStorage.getItem("vlink_active_client") || null
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setClients([]); setLoading(false); return;
    }
    setLoading(true);
    api.get("/clients").then((r) => {
      setClients(r.data);
      if (!activeClientId || !r.data.find((c) => c.id === activeClientId)) {
        const def = r.data[0]?.id;
        if (def) {
          setActiveClientId(def);
          localStorage.setItem("vlink_active_client", def);
        }
      }
    }).finally(() => setLoading(false));
  }, [user]); // eslint-disable-line

  function setActiveClient(id) {
    setActiveClientId(id);
    localStorage.setItem("vlink_active_client", id);
  }

  const activeClient = clients.find((c) => c.id === activeClientId) || null;

  return (
    <ClientContext.Provider value={{ clients, activeClient, activeClientId, setActiveClient, loading }}>
      {children}
    </ClientContext.Provider>
  );
}

export const useClient = () => useContext(ClientContext);
